import { defineComponent as _defineComponent } from 'vue'
import { ref, set, toRefs, watch } from 'vue';
import type { NewBookV1 } from '@ilteducation/content-registry-types';
import type { Language } from '@ilteducation/content-ref-data-types';
import { generateUid } from '@ilteducation/uid';
import ArrayInput from '@/components/base/ArrayInput.vue';
import CreatorNameFields from '@/components/book/CreatorNameFields.vue';
import type { BookCreatorDraft } from '@/types/bookCreator';

type Props = {
  availableLanguages: Language[];
  book: NewBookV1;
  fetchingMetadata: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'BookCreators',
  props: {
    availableLanguages: null,
    book: null,
    fetchingMetadata: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  availableLanguages: Language[];
  book: NewBookV1;
  fetchingMetadata: boolean;
}


const currentTab = ref<number>(0);

const authors = ref<BookCreatorDraft[]>([]);
const illustrators = ref<BookCreatorDraft[]>([]);
const translators = ref<BookCreatorDraft[]>([]);
const narrators = ref<BookCreatorDraft[]>([]);
const editors = ref<BookCreatorDraft[]>([]);
const coverDesigners = ref<BookCreatorDraft[]>([]);
const adapters = ref<BookCreatorDraft[]>([]);

const { book, fetchingMetadata } = toRefs(props);

/**
 * ArrayInput keys its rows by id and only generates one for rows it builds
 * itself. Creators from fetched metadata arrive without one, which would leave
 * several rows sharing an empty key - so they are given an id in place, keeping
 * the row objects the book payload is built from.
 */
const withRowIds = (creators?: BookCreatorDraft[]) =>
  creators?.map((creator) => Object.assign(creator, { id: creator.id ?? generateUid() }));

watch(fetchingMetadata, (newVal, oldValue) => {
  if (oldValue && !newVal) {
    authors.value = withRowIds(book.value.authors) ?? authors.value;
    illustrators.value = withRowIds(book.value.illustrators) ?? illustrators.value;
    translators.value = withRowIds(book.value.translators) ?? translators.value;
    narrators.value = withRowIds(book.value.narrators) ?? narrators.value;
    editors.value = withRowIds(book.value.editors) ?? editors.value;
    coverDesigners.value = withRowIds(book.value.coverDesigners) ?? coverDesigners.value;
    adapters.value = withRowIds(book.value.adapters) ?? adapters.value;
  }
});

/**
 * The ArrayInput rows are what the book payload is built from, so the edited name
 * components are merged straight back into the row. Through `set`, because a row
 * rarely arrives with every key - and a plain assignment would add one that
 * nothing can react to, leaving the row's own fields stale on screen.
 */
const updateCreator = (creator: BookCreatorDraft, draft: Partial<BookCreatorDraft>) =>
  Object.entries(draft).forEach(([field, value]) => set(creator, field, value));

return { __sfc: true,props, currentTab, authors, illustrators, translators, narrators, editors, coverDesigners, adapters, book, fetchingMetadata, withRowIds, updateCreator, ArrayInput, CreatorNameFields }
}

})